import { Button, Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  quickLinksButton: {
    [theme.breakpoints.down("md")]: {
      height: "36px",
      minWidth: "95vw",
      margin: "auto",
      marginTop: "5px",
      marginBottom: "5px",
    },
    width: "250px",
    height: "50px",
    color: theme.palette.secondary.swaWhite,
    fontSize: "14px",
    margin: "10px",
    paddingLeft: "40px",
    paddingRight: "40px",
    lineHeight: "16px",
  },
  toolTip: {
    fontSize: "12px",
    maxWidth: "200px",
    textAlign: "center",
  },
}));

const SpecialAccessQuickLink = (props) => {
  const classes = useStyles();
  return (
    <Tooltip key={props.idx} title={props.description} arrow placement="bottom" classes={classes.toolTip}>
      <Button
        key={props.idx}
        className={classes.quickLinksButton}
        variant="contained"
        color="primary"
        size="large"
        aria-label="large contained primary button group"
        onClick={props.onClick}
      >
        {props.label}
      </Button>
    </Tooltip>
  );
}

SpecialAccessQuickLink.propTypes = {
  idx: PropTypes.number.isRequired,
  description: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
}

export default SpecialAccessQuickLink;